import { Paper } from '@mantine/core';

export function Section({ children }: { children: React.ReactNode }) {
  return (
    <Paper
      p="02"
      radius="md"
      sx={theme => ({
        border: `1px solid ${theme.colors.gray[1]}`,
        boxShadow:
          '0px 4px 12px -2px rgba(0, 0, 0, 0.04), 0px 2px 4px -2px rgba(0, 0, 0, 0.04)',
      })}
    >
      {children}
    </Paper>
  );
}
